import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '../../models/common.interface';
import { AsyncValidatorsActions } from '../action/actions-type.action';

export interface AsyncValidatorsState {
    isUserNameUnique: boolean | null;
    isEmailUnique: boolean | null;
    isLoading: boolean;
    error: BadResponseWithError | null;
}

const initialState: AsyncValidatorsState = {
    isUserNameUnique: null,
    isEmailUnique: null,
    isLoading: false,
    error: null,
};

const reducer = createReducer(
    initialState,
    on(AsyncValidatorsActions.validateUsername, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(AsyncValidatorsActions.validateUsernameSuccess, (state, action) => ({
        ...state,
        isUserNameUnique: true,
        isLoading: false,
    })),
    on(AsyncValidatorsActions.validateUsernameFailure, (state, action) => ({
        ...state,
        isUserNameUnique: false,
        isLoading: false,
        error: action.payload,
    })),
    on(AsyncValidatorsActions.validateEmail, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(AsyncValidatorsActions.validateEmailSuccess, (state, action) => ({
        ...state,
        isEmailUnique: true,
        isLoading: false,
    })),
    on(AsyncValidatorsActions.validateEmailFailure, (state, action) => ({
        ...state,
        isEmailUnique: false,
        isLoading: false,
        error: action.payload,
    }))
);

export const asyncValidatorsReducer = (
    state: AsyncValidatorsState,
    action: Action
) => reducer(state, action);
